// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"QsPM4owB","logo":"vi3vGtv_","scaleLogo":"tQRELZcx","afterLogo":"wVFIaVkt","showInMenu":"_70GIKZ0y"};